import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input, Table, Typography, Space, Tooltip, Button, Badge, Row, Col, Tag, Spin, Popconfirm, Modal, DatePicker, Image } from 'antd';
import { EyeOutlined, SearchOutlined } from '@ant-design/icons';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import moment from 'moment';
import Utils from '../../../misc/Utils';
import Enums from '../../../misc/Enums';
import ProcessingModal from '../../../components/processing/ProcessingModal';
// import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';

const { Text, Link } = Typography;

export function ApplicationListMabalacat() {
   const navigate = useNavigate();
   const [searchText, setSearchText] = useState("");
   const [searchedColumn, setSearchedColumn] = useState("");

   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const customFormat = value => `${value.format('MMM. D, YYYY h:mm a')}`;
   // const subdomain = localStorage.getItem("lms-subdomain");

   const [legendCount, setLegendCount] = useState({
      pending: 0,
      accepted: 0,
      not_accepted: 0,
      ready_for_exam: 0,
      passed: 0,
      failed: 0,
      approved: 0,
      not_approved: 0,
      for_interview: 0,
      reconsidered: 0,
      rejected: 0
   });

   const [applicantList, setApplicantList] = useState([]);
   const [applicantListFiltered, setApplicantListFiltered] = useState([]);
   const [listLoading, setListLoading] = useState(false);
   const [updating, setUpdating] = useState(false);
   const [schedule, setSchedule] = useState(null);
   const [applicantID, setApplicantID] = useState(null);
   // const [validPoP, setValidPoP] = useState(false);
   const [docToView, setDocToView] = useState(null);
   const [bankDetails, setBankDetails] = useState(null);

   const [modalSchedule, setModalSchedule] = useState(false);
   const [modalPoPValidate, setModalPoPValidate] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      window.addEventListener('error', e => {
         if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            const resizeObserverErrDiv = document.getElementById(
               'webpack-dev-server-client-overlay-div'
            );
            const resizeObserverErr = document.getElementById(
               'webpack-dev-server-client-overlay'
            );
            if (resizeObserverErr) {
               resizeObserverErr.setAttribute('style', 'display: none');
            }
            if (resizeObserverErrDiv) {
               resizeObserverErrDiv.setAttribute('style', 'display: none');
            }
         }
      });

      getApplicants();
   }, []);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  Reset
               </Button>
               <Button
                  type="link"
                  size="small"
                  onClick={() => {
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Filter
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#033D89' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   // Helper function to create name column config
   const createNameColumn = (key, title, width) => ({
      title,
      key,
      sorter: (a, b) => a[key].localeCompare(b[key]),
      ...getColumnSearchProps(key),
      ellipsis: { showTitle: key !== 'last_name' },
      render: obj => (
         <Tooltip placement="topLeft" title={obj[key]}>
            <Text>
               <span style={{ textTransform: 'capitalize' }}>{obj[key]}</span>
            </Text>
         </Tooltip>
      ),
      width
   });

   // Helper function to create action button
   const createActionButton = (condition, props, content) =>
      condition && <Button type="primary" size="small" shape="round" {...props}>{content}</Button>;

   // Helper function to create popconfirm button
   const createPopconfirmButton = (condition, title, onConfirm, content) =>
      condition && (
         <Popconfirm title={title} onConfirm={onConfirm} okText="Yes" cancelText="No">
            <Button type="primary" size="small" shape="round">{content}</Button>
         </Popconfirm>
      );

   const columns = [
      { title: 'Id', key: 'id', dataIndex: 'id', hidden: true },
      createNameColumn('last_name', 'Last Name', '14%'),
      createNameColumn('first_name', 'First Name', '14%'),
      createNameColumn('middle_name', 'Middle Name', '14%'),
      {
         title: 'Gender',
         key: 'gender',
         sorter: (a, b) => a.gender.localeCompare(b.gender),
         ...getColumnSearchProps('gender'),
         ellipsis: { showTitle: true },
         render: obj => (
            <Text>
               {obj.gender && <span style={{ textTransform: 'capitalize' }}>{obj.gender}</span>}
            </Text>
         ),
         width: '8%'
      },
      {
         title: 'Date Applied',
         key: 'date_applied',
         sorter: (a, b) => a.date_applied.localeCompare(b.date_applied),
         ...getColumnSearchProps('date_applied'),
         ellipsis: { showTitle: true },
         render: obj => (
            <Text>{moment(obj.date_applied).format('MMM. DD, YYYY hh:mm:ss A')}</Text>
         ),
         width: '15%'
      },
      {
         title: 'Application Status',
         key: 'application_status',
         ...getColumnSearchProps('application_status'),
         ellipsis: { showTitle: true },
         render: obj => (
            <>
               {(!obj.exam_status && !['approved', 'for_interview', 'ready_for_exam'].includes(obj.application_status) && obj.is_pop_valid) && RenderTag('paid')}
               {(obj.exam_status && ['approved', 'for_interview', 'on_hold'].includes(obj.application_status)) && RenderTag(obj.exam_status)}
               {RenderTag(obj.application_status)}
            </>
         ),
         width: '22%'
      },
      {
         title: 'Action',
         key: 'action',
         render: ({ id, application_status: status, ...payload }) => (
            <Space size="small">
               {createActionButton(user_role === 'Cashier',
                  { onClick: () => handleViewDoc(id, payload.bank_details) },
                  <><EyeOutlined /> Proof of Payment</>
               )}
               {createActionButton(['Interviewer', 'Registrar'].includes(user_role) && status === 'approved',
                  { onClick: () => handleInterview(id, 'view') },
                  'Interview Result'
               )}
               {createActionButton(user_role === 'Registrar' && status !== 'approved',
                  { onClick: () => handleReviewApplication(id, status) },
                  status === 'pending' ? 'Review' : 'View'
               )}
               {createPopconfirmButton(user_role === 'Registrar' && status === 'ready_for_exam',
                  'Do you want to reset the exam schedule?',
                  () => handleChangeStatus(id),
                  'Reset Exam Schedule'
               )}
               {createPopconfirmButton(user_role === 'Registrar' && status === 'exam_failed',
                  'Do you want to reconsider this applicant?',
                  () => handleReconsider(id),
                  'Reconsider'
               )}
               {(user_role === 'Interviewer' && (['exam_passed', 'reconsidered'].includes(status))) && (
                  <>
                     <Button type="primary" size="small" shape="round" onClick={() => handleReviewApplication(id, status)}>View</Button>
                     <Button type="primary" size="small" shape="round" onClick={() => showModalSchedule(id, true)}>Set Interview</Button>
                  </>
               )}
               {(user_role === 'Interviewer' && (status === 'on_hold' || status === 'for_interview')) && (
                  payload.interview_ready ? (
                     status !== 'on_hold' ? (
                        <>
                           <Button type="primary" size="small" shape="round" onClick={() => handleInterview(id)}>Interview</Button>
                           <Button type="primary" size="small" shape="round" onClick={() => showModalSchedule(id, true)}>Re-schedule Interview</Button>
                        </>
                     ) : (
                        <Button type="primary" size="small" shape="round" onClick={() => handleInterview(id, 'edit-view')}>Interview</Button>
                     )
                  ) : (
                     <Button type="primary" size="small" shape="round">Schedule: {payload.interview_schedule}</Button>
                  )
               )}
            </Space>
         ),
         width: '20%'
      }
   ].filter(item => !item.hidden);

   const getApplicants = async () => {
      setListLoading(true);
      try {
         const { data } = await axios.get(`${process.env.REACT_APP_API_CPH}/getonlineapplicants`);
         if (data) {
            const legendCount = data.reduce((counts, { application_status }) => {
               const status = application_status === 'on_hold' ? 'for_interview' : application_status;
               counts[status] = (counts[status] || 0) + 1;
               return counts;
            }, {
               pending: 0,
               accepted: 0,
               rejected: 0,
               ready_for_exam: 0,
               passed: 0,
               failed: 0,
               approved: 0,
               not_approved: 0,
               for_interview: 0,
               reconsidered: 0,
            });

            setLegendCount(legendCount);
            setApplicantList(data);
            setApplicantListFiltered(data);
         }
      } catch (error) {
         console.error('Failed to fetch applicants:', error.message);
      } finally {
         setListLoading(false);
      }
   };

   const RenderTag = (status) => {
      var color = '';

      switch (status) {
         case 'pending':
            color = 'gold';
            break;
         case 'accepted':
            color = 'green'
            break;
         case 'rejected':
            color = 'red';
            break;
         case 'ready_for_exam':
            color = 'pink';
            break;
         case 'exam_passed':
            color = 'green';
            break;
         case 'exam_failed':
            color = 'red';
            break;
         case 'approved':
            color = 'cyan';
            break;
         case 'not_approved':
            color = 'red';
            break;
         case 'on_hold':
         case 'for_interview':
            color = 'blue';
            break;
         case 'reconsidered':
            color = 'purple';
            break;
         case 'paid':
            color = 'cyan';
            break;
         case 'enrolled':
            color = 'green';
            break;
         default:
      }

      return <>
         <Tag color={color}>
            {
               status === 'on_hold'
                  ?
                  'INTERVIEW ' + status.replace(/_/g, ' ').toUpperCase()
                  :
                  status.replace(/_/g, ' ').toUpperCase()
            }
         </Tag>
      </>
   }

   const RenderStatusCounts = () => {
      return <>
         <div style={{ overflow: 'auto' }}>
            <Row style={{ paddingTop: "20px", minWidth: '600px', marginBottom: '20px' }} >
               <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Space size={'middle'}>
                     <Badge count={legendCount.pending} style={{ backgroundColor: 'gold' }} overflowCount={999}>
                        <Tag
                           color={"gold"}
                           style={{ cursor: legendCount.pending > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('pending')}
                        >
                           PENDING
                        </Tag>
                     </Badge>
                     <Badge count={legendCount.accepted} style={{ backgroundColor: 'green' }} overflowCount={999}>
                        <Tag
                           color={"green"}
                           style={{ cursor: legendCount.accepted > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('accepted')}
                        >
                           ACCEPTED
                        </Tag>
                     </Badge>
                     <Badge count={legendCount.rejected} style={{ backgroundColor: 'red' }} overflowCount={999}>
                        <Tag
                           color={"red"}
                           style={{ cursor: legendCount.rejected > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('rejected')}
                        >
                           REJECTED
                        </Tag>
                     </Badge>
                     <Badge count={legendCount.ready_for_exam} style={{ backgroundColor: 'pink' }} overflowCount={999}>
                        <Tag
                           color={"pink"}
                           style={{ cursor: legendCount.ready_for_exam > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('ready_for_exam')}
                        >
                           READY FOR EXAM
                        </Tag>
                     </Badge>
                     <Badge count={legendCount.passed} style={{ backgroundColor: 'green' }} overflowCount={999}>
                        <Tag
                           color={"green"}
                           style={{ cursor: legendCount.passed > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('exam_passed')}
                        >
                           EXAM PASSED
                        </Tag>
                     </Badge>
                     <Badge count={legendCount.failed} style={{ backgroundColor: 'red' }} overflowCount={999}>
                        <Tag
                           color={"red"}
                           style={{ cursor: legendCount.failed > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('exam_failed')}
                        >
                           EXAM FAILED
                        </Tag>
                     </Badge>
                     <Badge count={legendCount.reconsidered} style={{ backgroundColor: 'purple' }} overflowCount={999}>
                        <Tag
                           color={"purple"}
                           style={{ cursor: legendCount.reconsidered > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('reconsidered')}
                        >
                           RECONSIDERED
                        </Tag>
                     </Badge>
                     <Badge count={legendCount.for_interview} style={{ backgroundColor: 'blue' }} overflowCount={999}>
                        <Tag
                           color={"blue"}
                           style={{ cursor: legendCount.for_interview > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('for_interview')}
                        >
                           FOR INTERVIEW
                        </Tag>
                     </Badge>
                     <Badge count={legendCount.approved} style={{ backgroundColor: 'cyan' }} overflowCount={999}>
                        <Tag
                           color={"cyan"}
                           style={{ cursor: legendCount.approved > 0 ? 'pointer' : 'default', padding: '7px' }}
                           onClick={() => handleFilterListByStatus('approved')}
                        >
                           APPROVED
                        </Tag>
                     </Badge>
                     <Button className='button-shadow' type='primary' shape='round' onClick={() => getApplicants()}>Refresh</Button>
                  </Space>
               </Col>
            </Row>
         </div>
      </>
   }

   const handleFilterListByStatus = (status) => {
      var filteredList = applicantList.filter(student => student.application_status === status);

      setApplicantListFiltered(filteredList);
   }

   const handleReviewApplication = (id, status) => {
      navigate(`/reviewapplication?id=${id}`, { state: { status } });
   }

   const handleReconsider = (id) => {
      setUpdating(true);
      var url = `${process.env.REACT_APP_API_CPH}/reconsiderapplicant?id=${id}`;

      axios.post(url).then((response) => {
         if (response.data) {
            setUpdating(false);

            Modal.success({
               title: 'Online Application',
               content: 'Reconsider successful.',
               centered: true,
               onOk: getApplicants(),
            });
         }
      }, (error) => {
         setUpdating(false);

         Modal.error({
            title: 'Online Application',
            content: 'Reconsider failed.',
            centered: true
         });
         console.log(error.message);
      });
   }

   const showModalSchedule = (applicant_id, show) => {
      setApplicantID(applicant_id);
      setModalSchedule(show);
   }

   const handleSetInterviewSchedule = () => {
      setModalSchedule(false);
      setUpdating(true);
      var url = `${process.env.REACT_APP_API_CPH}/setinterviewschedule?id=${applicantID}&sched=${moment(schedule).format("YYYY-MM-DD HH:mm:ss")}`;

      axios.post(url).then((response) => {
         if (response.data) {
            setModalSchedule(false);
            setUpdating(false);
            Modal.success({
               title: 'Online Application',
               content: 'Setting interview schedule successful.',
               centered: true,
               onOk: getApplicants(),
            });
         }
      }, (error) => {
         setModalSchedule(false);
         setUpdating(false);
         Modal.error({
            title: 'Online Application',
            content: 'Setting interview schedule failed.',
            centered: true
         });
         console.log(error.message);
      });
   }

   const handleInterview = (id, mode = 'edit') => {
      navigate(`/interview?id=${id}`, { state: { mode } });
   }

   const handleViewDoc = (id, bank_details) => {
      //-- Get proof of payment url from documents
      var items = applicantListFiltered.filter(item => item.id === id);
      let docs = JSON.parse(items[0].documents);

      setBankDetails(bank_details);
      setDocToView(docs.proof_of_payment);
      setApplicantID(id);
      setModalPoPValidate(true);
   }

   const handleMarkAsPaid = (val) => {
      setUpdating(true);

      var url = `${process.env.REACT_APP_API_CPH}/markaspaid?id=${applicantID}&v=${val}`;

      axios.post(url).then((response) => {
         if (response.data) {
            setModalPoPValidate(false);
            setUpdating(false);
            Modal.success({
               title: 'Online Application',
               content: 'Setting mark as paid successful.',
               centered: true,
               onOk: getApplicants(),
            });
         }
      }, (error) => {
         setModalPoPValidate(false);
         setUpdating(false);
         Modal.error({
            title: 'Online Application',
            content: 'Setting mark as paid failed.',
            centered: true
         });
      });
   }

   const handleChangeStatus = async (id) => {
      try {
         setUpdating(true);
         const url = `${process.env.REACT_APP_API_CPH}/changeapplicationstatus?id=${id}&ns=accepted`;
         const response = await axios.post(url);

         if (response.data) {
            setUpdating(false);
            Modal.success({
               title: 'Online Application',
               content: 'Change status successful.',
               centered: true,
               onOk: getApplicants,
            });
         }
      } catch (error) {
         setUpdating(false);
         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true,
         });
      }
   };

   return (
      <>
         <ProcessingModal
            processing={updating}
            title={'Brainee LMS'}
         />
         <div className="dashboard-area-all">
            <div className="dashboard-item">
               <Spin size='large' spinning={updating} tip="Processing request...Please wait.">
                  <div className="dashboard-item-inner">
                     <ul>
                        <li className="active">Student Applicants Tracker</li>
                     </ul>
                  </div>

                  <div className="dashboard-item-inner3">
                     {RenderStatusCounts()}
                     <Table
                        loading={listLoading}
                        size='small'
                        rowKey={'uid'}
                        columns={columns}
                        dataSource={applicantListFiltered}
                        pagination={false}
                        scroll={{
                           x: '1000px',
                           y: 'calc(100vh - 17.5rem)',
                        }}
                        footer={() => 'Total Records: ' + applicantListFiltered.length}
                     />
                  </div>
               </Spin>
            </div>
         </div>

         <Modal
            key="modal-schedule"
            title='Online Application'
            destroyOnClose={true}
            centered
            okText={"Set"}
            cancelText={"Close"}
            open={modalSchedule}
            okButtonProps={{ shape: "round" }}
            cancelButtonProps={{ shape: "round" }}
            onOk={() => handleSetInterviewSchedule()}
            onCancel={() => setModalSchedule(false)}
         >
            <Text style={{ verticalAlign: "middle" }}>Set Interview Schedule</Text>
            <DatePicker
               placeholder="Select Date"
               showTime={{ format: 'hh:mm A', use12Hours: true }}
               format={customFormat}
               style={{ width: "100%" }}
               // disabledDate={(current) => current && current < moment().endOf('day')}
               //disabledDate={(current) => current < moment().endOf('day')}
               disabledDate={(current) => current.isBefore(moment().subtract(1, "day"))}
               onBlur={(event) => setSchedule(event.target.value)}
            />
         </Modal>

         <Modal
            key='pop-validate'
            title={"Validate Proof of Payment"}
            okText={"Paid"}
            cancelText={'Not Paid'}
            okButtonProps={{ type: 'primary', shape: "round" }}
            cancelButtonProps={{ type: 'primary', shape: 'round' }}
            centered
            destroyOnClose={true}
            open={modalPoPValidate}
            width='75%'

            // onCancel={() => { handleMarkAsPaid(false); }}
            // onOk={() => { handleMarkAsPaid(true) }}

            footer={[
               <Button key="paid" type='primary' shape='round' onClick={() => handleMarkAsPaid(true)}>Paid</Button>,
               <Button key="notpaid" type='primary' shape='round' onClick={() => handleMarkAsPaid(false)}>Not Paid</Button>,
               <Button key="close" type="primary" shape='round' onClick={() => setModalPoPValidate(false)}>Close</Button>
            ]}
         >
            <div className='essay_list_container' style={{ background: "#fff" }}>
               <div
                  className={'modal-document-viewer'}
                  style={{ height: "calc(100vh - 220px)" }}
               >
                  <Image
                     // src={`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${docToView}`}
                     src={docToView}
                     style={{ minHeight: "calc(100vh - 220px)", maxHeight: "calc(100vh - 220px)" }}
                  />

               </div>
               <div><Text>Bank Details: <b>{bankDetails}</b></Text></div>
            </div>
         </Modal>
      </>
   );
}
